import { styled } from "@mui/material/styles";

import Logo from "./Logo";

export const StyledImage = styled("img")<Logo>(({ height, width }) => ({
  height,
  minHeight: height,
  minWidth: width,
  maxWidth: "100%",
  width,
}));
